import { create } from 'zustand';
import type { AppState } from '@/types';

export const useAppStore = create<AppState>((set) => ({
  selectedCountry: null,
  selectedClient: null,
  actions: [],
  loading: false,
  error: null,
  showDeleted: false,

  setSelectedCountry: (country) =>
    set({
      selectedCountry: country,
      selectedClient: null, // Reset client cuando cambia país
      actions: [], // Clear actions
    }),

  setSelectedClient: (client) =>
    set({
      selectedClient: client,
      actions: [], // Clear actions hasta que se carguen nuevas
    }),

  setActions: (actions) =>
    set({ actions, loading: false, error: null }),

  setLoading: (loading) =>
    set({ loading }),

  setError: (error) =>
    set({ error, loading: false }),

  clearError: () =>
    set({ error: null }),

  setShowDeleted: (show) =>
    set({ showDeleted: show }),
}));
